'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var debug = require('debug');

var globalThis = require('ipfs-utils/src/globalthis');

var log = debug('libp2p');
log.error = debug('libp2p:error');

var PeerInfo = require('peer-info');

var peerRouting = require('./peer-routing');

var contentRouting = require('./content-routing');

var pubsub = require('./pubsub');

var _require2 = require('./get-peer-info'),
    getPeerInfo = _require2.getPeerInfo;

var _require3 = require('./config'),
    validateConfig = _require3.validate;

var _require4 = require('./errors'),
    codes = _require4.codes;

var ConnectionManager = require('./connection-manager');

var Circuit = require('./circuit');

var Dialer = require('./dialer');

var Metrics = require('./metrics');

var TransportManager = require('./transport-manager');

var Upgrader = require('./upgrader');

var PeerStore = require('./peer-store');

var Registrar = require('./registrar');

var _ping = require('./ping');

var _require5 = require('./identify'),
    IdentifyService = _require5.IdentifyService,
    IDENTIFY_PROTOCOLS = _require5.multicodecs;
/**
 * @fires Libp2p#error Emitted when an error occurs
 * @fires Libp2p#peer:connect Emitted when a peer is connected to this node
 * @fires Libp2p#peer:disconnect Emitted when a peer disconnects from this node
 * @fires Libp2p#peer:discovery Emitted when a peer is discovered
 */


var Libp2p = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Libp2p, _EventEmitter);

  var _super = _createSuper(Libp2p);

  function Libp2p(_options) {
    var _this;

    _classCallCheck(this, Libp2p);

    _this = _super.call(this); // validateConfig will ensure the config is correct,
    // and add default values where appropriate

    _this._options = validateConfig(_options);
    _this.datastore = _this._options.datastore;
    _this.peerInfo = _this._options.peerInfo;
    _this.peerStore = new PeerStore();
    _this._modules = _this._options.modules;
    _this._config = _this._options.config;
    _this._transport = []; // Transport instances/references

    _this._discovery = new Map(); // Discovery service instances/references

    if (_this._options.metrics.enabled) {
      _this.metrics = new Metrics(_this._options.metrics);
    } // Setup the Upgrader


    _this.upgrader = new Upgrader({
      localPeer: _this.peerInfo.id,
      metrics: _this.metrics,
      onConnection: function onConnection(connection) {
        var peerInfo = _this.peerStore.put(new PeerInfo(connection.remotePeer), {
          silent: true
        });

        _this.registrar.onConnect(peerInfo, connection);

        _this.connectionManager.onConnect(connection);

        _this.emit('peer:connect', peerInfo); // Run identify for every connection


        if (_this.identifyService) {
          _this.identifyService.identify(connection, connection.remotePeer).catch(log.error);
        }
      },
      onConnectionEnd: function onConnectionEnd(connection) {
        var peerInfo = Dialer.getDialable(connection.remotePeer);

        _this.registrar.onDisconnect(peerInfo, connection);

        _this.connectionManager.onDisconnect(connection); // If there are no connections to the peer, disconnect


        if (!_this.registrar.getConnection(peerInfo)) {
          _this.emit('peer:disconnect', peerInfo);

          _this.metrics && _this.metrics.onPeerDisconnected(peerInfo.id);
        }
      }
    }); // Create the Registrar

    _this.registrar = new Registrar({
      peerStore: _this.peerStore
    });
    _this.handle = _this.handle.bind(_assertThisInitialized(_this));
    _this.registrar.handle = _this.handle; // Create the Connection Manager

    _this.connectionManager = new ConnectionManager(_assertThisInitialized(_this), _this._options.connectionManager); // Setup the transport manager

    _this.transportManager = new TransportManager({
      libp2p: _assertThisInitialized(_this),
      upgrader: _this.upgrader
    }); // Attach crypto channels

    if (_this._modules.connEncryption) {
      var cryptos = _this._modules.connEncryption;
      cryptos.forEach(function (crypto) {
        _this.upgrader.cryptos.set(crypto.protocol, crypto);
      });
    }

    _this.dialer = new Dialer({
      transportManager: _this.transportManager,
      peerStore: _this.peerStore,
      concurrency: _this._options.dialer.maxParallelDials,
      perPeerLimit: _this._options.dialer.maxDialsPerPeer,
      timeout: _this._options.dialer.dialTimeout
    });

    _this._modules.transport.forEach(function (Transport) {
      var key = Transport.prototype[Symbol.toStringTag];
      var transportOptions = _this._config.transport[key];

      _this.transportManager.add(key, Transport, transportOptions);
    });

    if (_this._config.relay.enabled) {
      _this.transportManager.add(Circuit.prototype[Symbol.toStringTag], Circuit);
    } // Attach stream multiplexers


    if (_this._modules.streamMuxer) {
      var muxers = _this._modules.streamMuxer;
      muxers.forEach(function (muxer) {
        _this.upgrader.muxers.set(muxer.multicodec, muxer);
      }); // Add the identify service since we can multiplex

      _this.identifyService = new IdentifyService({
        registrar: _this.registrar,
        peerInfo: _this.peerInfo,
        protocols: _this.upgrader.protocols
      });

      _this.handle(Object.values(IDENTIFY_PROTOCOLS), _this.identifyService.handleMessage);
    } // Attach private network protector


    if (_this._modules.connProtector) {
      _this.upgrader.protector = _this._modules.connProtector;
    } else if (globalThis.process !== undefined && globalThis.process.env && globalThis.process.env.LIBP2P_FORCE_PNET) {
      throw new Error('Private network is enforced, but no protector was provided');
    } // dht provided components (peerRouting, contentRouting, dht)


    if (_this._modules.dht) {
      var DHT = _this._modules.dht;
      _this._dht = new DHT(_objectSpread({
        dialer: _this.dialer,
        peerInfo: _this.peerInfo,
        peerStore: _this.peerStore,
        registrar: _this.registrar,
        datastore: _this.datastore
      }, _this._config.dht));
    } // start pubsub


    if (_this._modules.pubsub) {
      _this.pubsub = pubsub(_assertThisInitialized(_this), _this._modules.pubsub, _this._config.pubsub);
    } // Attach remaining APIs
    // peer and content routing will automatically get modules from _modules and _dht


    _this.peerRouting = peerRouting(_assertThisInitialized(_this));
    _this.contentRouting = contentRouting(_assertThisInitialized(_this)); // Mount default protocols

    _ping.mount(_assertThisInitialized(_this));

    _this._onDiscoveryPeer = _this._onDiscoveryPeer.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Overrides EventEmitter.emit to conditionally emit errors
   * if there is a handler. If not, errors will be logged.
   * @param {string} eventName
   * @param  {...any} args
   * @returns {void}
   */


  _createClass(Libp2p, [{
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (eventName === 'error' && !this._events.error) {
        log.error.apply(log, args);
      } else {
        var _get2;

        (_get2 = _get(_getPrototypeOf(Libp2p.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
      }
    }
    /**
     * Starts the libp2p node and all its subsystems
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('libp2p is starting');
                _context.prev = 1;
                _context.next = 4;
                return this._onStarting();

              case 4:
                _context.next = 6;
                return this._onDidStart();

              case 6:
                log('libp2p has started');
                _context.next = 16;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                this.emit('error', _context.t0);
                log.error('An error occurred starting libp2p', _context.t0);
                _context.next = 15;
                return this.stop();

              case 15:
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Stop the libp2p node by closing its listeners and open connections
     * @async
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator, _step, service;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                log('libp2p is stopping');
                _context2.prev = 1;
                _iterator = _createForOfIteratorHelper(this._discovery.values());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    service = _step.value;
                    service.removeListener('peer', this._onDiscoveryPeer);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context2.next = 6;
                return Promise.all(Array.from(this._discovery.values(), function (s) {
                  return s.stop();
                }));

              case 6:
                this._discovery = new Map();
                this.connectionManager.stop();
                _context2.next = 10;
                return Promise.all([this.pubsub && this.pubsub.stop(), this._dht && this._dht.stop(), this.metrics && this.metrics.stop()]);

              case 10:
                _context2.next = 12;
                return this.transportManager.close();

              case 12:
                _context2.next = 14;
                return this.registrar.close();

              case 14:
                _ping.unmount(this);

                this.dialer.destroy();
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](1);

                if (_context2.t0) {
                  log.error(_context2.t0);
                  this.emit('error', _context2.t0);
                }

              case 21:
                this._isStarted = false;
                log('libp2p has stopped');

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 18]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "isStarted",
    value: function isStarted() {
      return this._isStarted;
    }
    /**
     * Gets a Map of the current connections. The keys are the stringified
     * `PeerId` of the peer. The value is an array of Connections to that peer.
     * @returns {Map<string, Connection[]>}
     */

  }, {
    key: "dial",

    /**
     * Dials to the provided peer. If successful, the `PeerInfo` of the
     * peer will be added to the nodes `peerStore`
     *
     * @param {PeerInfo|PeerId|Multiaddr|string} peer The peer to dial
     * @param {object} options
     * @param {AbortSignal} [options.signal]
     * @returns {Promise<Connection>}
     */
    value: function dial(peer, options) {
      return this.dialProtocol(peer, null, options);
    }
    /**
     * Dials to the provided peer and handshakes with the given protocol.
     * If successful, the `PeerInfo` of the peer will be added to the nodes `peerStore`,
     * and the `Connection` will be sent in the callback
     *
     * @async
     * @param {PeerInfo|PeerId|Multiaddr|string} peer The peer to dial
     * @param {string[]|string} protocols
     * @param {object} options
     * @param {AbortSignal} [options.signal]
     * @returns {Promise<Connection|*>}
     */

  }, {
    key: "dialProtocol",
    value: function () {
      var _dialProtocol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peer, protocols, options) {
        var dialable, connection;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dialable = Dialer.getDialable(peer);

                if (PeerInfo.isPeerInfo(dialable)) {
                  this.peerStore.put(dialable, {
                    silent: true
                  });
                  connection = this.registrar.getConnection(dialable);
                }

                if (connection) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return this.dialer.connectToPeer(dialable, options);

              case 5:
                connection = _context3.sent;

              case 6:
                if (!protocols) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", connection.newStream(protocols));

              case 8:
                return _context3.abrupt("return", connection);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function dialProtocol(_x, _x2, _x3) {
        return _dialProtocol.apply(this, arguments);
      }

      return dialProtocol;
    }()
    /**
     * Disconnects all connections to the given `peer`
     *
     * @param {PeerInfo|PeerId|multiaddr|string} peer the peer to close connections to
     * @returns {Promise<void>}
     */

  }, {
    key: "hangUp",
    value: function () {
      var _hangUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
        var peerInfo, connections;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                peerInfo = getPeerInfo(peer, this.peerStore);
                connections = this.registrar.connections.get(peerInfo.id.toB58String());

                if (connections) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return Promise.all(connections.map(function (connection) {
                  return connection.close();
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hangUp(_x4) {
        return _hangUp.apply(this, arguments);
      }

      return hangUp;
    }()
    /**
     * Pings the given peer
     * @param {PeerInfo|PeerId|Multiaddr|string} peer The peer to ping
     * @returns {Promise<number>}
     */

  }, {
    key: "ping",
    value: function () {
      var _ping2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(peer) {
        var peerInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getPeerInfo(peer, this.peerStore);

              case 2:
                peerInfo = _context5.sent;
                return _context5.abrupt("return", _ping(this, peerInfo));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function ping(_x5) {
        return _ping2.apply(this, arguments);
      }

      return ping;
    }()
    /**
     * Registers the `handler` for each protocol
     * @param {string[]|string} protocols
     * @param {function({ connection:*, stream:*, protocol:string })} handler
     */

  }, {
    key: "handle",
    value: function handle(protocols, handler) {
      var _this2 = this;

      protocols = Array.isArray(protocols) ? protocols : [protocols];
      protocols.forEach(function (protocol) {
        _this2.upgrader.protocols.set(protocol, handler);
      }); // Only push if libp2p is running

      if (this.isStarted() && this.identifyService) {
        this.identifyService.pushToPeerStore(this.peerStore);
      }
    }
    /**
     * Removes the handler for each protocol. The protocol
     * will no longer be supported on streams.
     * @param {string[]|string} protocols
     */

  }, {
    key: "unhandle",
    value: function unhandle(protocols) {
      var _this3 = this;

      protocols = Array.isArray(protocols) ? protocols : [protocols];
      protocols.forEach(function (protocol) {
        _this3.upgrader.protocols.delete(protocol);
      }); // Only push if libp2p is running

      if (this.isStarted() && this.identifyService) {
        this.identifyService.pushToPeerStore(this.peerStore);
      }
    }
  }, {
    key: "_onStarting",
    value: function () {
      var _onStarting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var multiaddrs, _iterator2, _step2, ma;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // Listen on the addresses supplied in the peerInfo
                multiaddrs = this.peerInfo.multiaddrs.toArray();
                _context6.next = 3;
                return this.transportManager.listen(multiaddrs);

              case 3:
                // The addresses may change once the listener starts
                // eg /ip4/0.0.0.0/tcp/0 => /ip4/192.168.1.0/tcp/58751
                this.peerInfo.multiaddrs.clear();
                _iterator2 = _createForOfIteratorHelper(this.transportManager.getAddrs());

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    ma = _step2.value;
                    this.peerInfo.multiaddrs.add(ma);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (this._config.pubsub.enabled) {
                  this.pubsub && this.pubsub.start();
                } // DHT subsystem


                if (this._config.dht.enabled) {
                  this._dht && this._dht.start(); // TODO: this should be modified once random-walk is used as
                  // the other discovery modules

                  this._dht.on('peer', this._onDiscoveryPeer);
                } // Start metrics if present


                this.metrics && this.metrics.start();

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _onStarting() {
        return _onStarting2.apply(this, arguments);
      }

      return _onStarting;
    }()
    /**
     * Called when libp2p has started and before it returns
     * @private
     */

  }, {
    key: "_onDidStart",
    value: function () {
      var _onDidStart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this4 = this;

        var _iterator3, _step3, peerInfo;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this._isStarted = true;
                this.connectionManager.start();
                this.peerStore.on('peer', function (peerInfo) {
                  _this4.emit('peer:discovery', peerInfo);

                  _this4._maybeConnect(peerInfo);
                }); // Peer discovery

                _context7.next = 5;
                return this._setupPeerDiscovery();

              case 5:
                // Once we start, emit and dial any peers we may have already discovered
                _iterator3 = _createForOfIteratorHelper(this.peerStore.peers.values());

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    peerInfo = _step3.value;
                    this.emit('peer:discovery', peerInfo);

                    this._maybeConnect(peerInfo);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _onDidStart() {
        return _onDidStart2.apply(this, arguments);
      }

      return _onDidStart;
    }()
    /**
     * Called whenever peer discovery services emit `peer` events.
     * Known peers may be emitted.
     * @private
     * @param {PeerInfo} peerInfo
     */

  }, {
    key: "_onDiscoveryPeer",
    value: function _onDiscoveryPeer(peerInfo) {
      if (peerInfo.id.toB58String() === this.peerInfo.id.toB58String()) {
        log.error(new Error(codes.ERR_DISCOVERED_SELF));
        return;
      }

      this.peerStore.put(peerInfo);
    }
    /**
     * Will dial to the given `peerInfo` if the current number of
     * connected peers is less than the configured `ConnectionManager`
     * minPeers.
     * @private
     * @param {PeerInfo} peerInfo
     */

  }, {
    key: "_maybeConnect",
    value: function () {
      var _maybeConnect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(peerInfo) {
        var minPeers;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this._config.peerDiscovery.autoDial === true && !this.registrar.getConnection(peerInfo))) {
                  _context8.next = 12;
                  break;
                }

                minPeers = this._options.connectionManager.minPeers || 0;

                if (!(minPeers > this.connectionManager._connections.size)) {
                  _context8.next = 12;
                  break;
                }

                log('connecting to discovered peer %s', peerInfo.id.toB58String());
                _context8.prev = 4;
                _context8.next = 7;
                return this.dialer.connectToPeer(peerInfo);

              case 7:
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](4);
                log.error('could not connect to discovered peer', _context8.t0);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[4, 9]]);
      }));

      function _maybeConnect(_x6) {
        return _maybeConnect2.apply(this, arguments);
      }

      return _maybeConnect;
    }()
    /**
     * Initializes and starts peer discovery services
     *
     * @async
     * @private
     */

  }, {
    key: "_setupPeerDiscovery",
    value: function () {
      var _setupPeerDiscovery2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this5 = this;

        var setupService, _iterator4, _step4, DiscoveryService, _iterator5, _step5, Transport;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                setupService = function setupService(DiscoveryService) {
                  var config = {
                    enabled: true // on by default

                  };

                  if (DiscoveryService.tag && _this5._config.peerDiscovery && _this5._config.peerDiscovery[DiscoveryService.tag]) {
                    config = _objectSpread(_objectSpread({}, config), _this5._config.peerDiscovery[DiscoveryService.tag]);
                  }

                  if (config.enabled && !_this5._discovery.has(DiscoveryService.tag)) {
                    // not already added
                    var discoveryService;

                    if (typeof DiscoveryService === 'function') {
                      discoveryService = new DiscoveryService(Object.assign({}, config, {
                        peerInfo: _this5.peerInfo,
                        libp2p: _this5
                      }));
                    } else {
                      discoveryService = DiscoveryService;
                    }

                    discoveryService.on('peer', _this5._onDiscoveryPeer);

                    _this5._discovery.set(DiscoveryService.tag, discoveryService);
                  }
                }; // Discovery modules


                _iterator4 = _createForOfIteratorHelper(this._modules.peerDiscovery || []);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    DiscoveryService = _step4.value;
                    setupService(DiscoveryService);
                  } // Transport modules with discovery

                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                _iterator5 = _createForOfIteratorHelper(this.transportManager.getTransports());

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    Transport = _step5.value;

                    if (Transport.discovery) {
                      setupService(Transport.discovery);
                    }
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                _context9.next = 7;
                return Promise.all(Array.from(this._discovery.values(), function (d) {
                  return d.start();
                }));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _setupPeerDiscovery() {
        return _setupPeerDiscovery2.apply(this, arguments);
      }

      return _setupPeerDiscovery;
    }()
  }, {
    key: "connections",
    get: function get() {
      return this.registrar.connections;
    }
  }]);

  return Libp2p;
}(EventEmitter);
/**
 * Like `new Libp2p(options)` except it will create a `PeerInfo`
 * instance if one is not provided in options.
 * @param {object} options Libp2p configuration options
 * @returns {Libp2p}
 */


Libp2p.create = /*#__PURE__*/function () {
  var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var options,
        peerInfo,
        _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            options = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};

            if (!options.peerInfo) {
              _context10.next = 3;
              break;
            }

            return _context10.abrupt("return", new Libp2p(options));

          case 3:
            _context10.next = 5;
            return PeerInfo.create();

          case 5:
            peerInfo = _context10.sent;
            options.peerInfo = peerInfo;
            return _context10.abrupt("return", new Libp2p(options));

          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  function create() {
    return _create.apply(this, arguments);
  }

  return create;
}();

module.exports = Libp2p;